import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/ui/layout.js";
import { Link } from 'gatsby';
import EpubExample from '~/examples/epub';
import { SourceCode } from '~/ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <blockquote>
      <p parentName="blockquote">{`This is an experimental example.  The implementation and features are subject to change.`}</p>
    </blockquote>
    <p>{`This example uses a custom EPUB parser to parse the EPUB file archive into HTML pages.  With the EPUB book represented by a collection of HTML documents, we can benefit from all `}<inlineCode parentName="p">{`unified-doc`}</inlineCode>{` APIs (e.g. render, search, export, marks etc).`}</p>
    <SourceCode source="examples/epub" mdxType="SourceCode" />
    <h3 {...{
      "id": "features"
    }}>{`Features`}</h3>
    <ul>
      <li parentName="ul">{`Features from the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview`}</Link>{` example apply here.`}</li>
      <li parentName="ul">{`Upload and preview any `}<inlineCode parentName="li">{`.epub`}</inlineCode>{` file using the `}<inlineCode parentName="li">{`DocPreview`}</inlineCode>{` component.`}</li>
      <li parentName="ul">{`Pagination support.`}</li>
    </ul>
    <h3 {...{
      "id": "concepts"
    }}>{`Concepts`}</h3>
    <ul>
      <li parentName="ul">{`Most concepts from the `}<Link to="/examples/doc-preview" mdxType="Link">{`Doc preview`}</Link>{` example apply here.`}</li>
      <li parentName="ul">{`Advanced async parsers to convert complex source data into an array of `}<inlineCode parentName="li">{`content`}</inlineCode>{`, `}<inlineCode parentName="li">{`filename`}</inlineCode>{` compatible with `}<inlineCode parentName="li">{`unified-doc`}</inlineCode>{`.`}</li>
    </ul>
    <h3 {...{
      "id": "demo"
    }}>{`Demo`}</h3>
    <EpubExample mdxType="EpubExample" />
    {
      /* Definitions */
    }

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      